module.exports = "<!-- <button class=\"wg-icon\" md-button mdTooltip=\"forward 10 seconds\" mdTooltipPosition=\"above\" (click)=\"onForward()\">\n  <i class=\"material-icons ml-10\">forward_10</i>\n</button> -->\n\n<i class=\"fa fa-fast-forward fa-x\" title=\"forward 10 seconds\" aria-hidden=\"true\" (click)=\"onForward()\"></i>"


//////////////////
// WEBPACK FOOTER
// ./src/app/player/forward-play/forward-play.component.html
// module id = ./src/app/player/forward-play/forward-play.component.html
// module chunks = main